import React from "react";
import "../styles/Footer.css"

function Footer() {
    return (
      <footer className="bg-dark footer text-white">
        <div className="card-header bg-dark text-white">
        &copy; FSC 2020
        </div>

      </footer>
    );
  }
  
  export default Footer;